export function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <h1 className="legal-title">Terms of Service</h1>
        <p className="legal-updated">Last Updated: February 9, 2026</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing or using GlitchedDeals' website, Discord community, or any of our
              services, you agree to be bound by these Terms of Service. If you do not agree
              to these terms, please do not use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>Description of Service</h2>
            <p>
              GlitchedDeals provides information about online deals, discounts, and price
              errors from various retailers. Our services include:
            </p>
            <ul>
              <li>Deal alerts and notifications</li>
              <li>Community discussion forums (Discord)</li>
              <li>Price error tracking</li>
              <li>Coupon codes and promotional information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>User Responsibilities</h2>
            <p>When using our services, you agree to:</p>
            <ul>
              <li>Provide accurate information</li>
              <li>Not engage in fraudulent or illegal activities</li>
              <li>Not abuse or exploit deals in ways that violate retailer terms</li>
              <li>Respect other community members</li>
              <li>Not spam or post promotional content without permission</li>
              <li>Follow Discord community guidelines</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Deal Information Disclaimer</h2>
            <p>
              <strong>Important:</strong> All deal information is provided for informational
              purposes only. We make no guarantees regarding:
            </p>
            <ul>
              <li>Accuracy of pricing information</li>
              <li>Availability of products or deals</li>
              <li>Validity or acceptance of coupon codes</li>
              <li>Duration of deals or price errors</li>
            </ul>
            <p>
              Deals, prices, and availability can change at any time without notice.
              Always verify information directly with the retailer before making a purchase.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Affiliation with Retailers</h2>
            <p>
              GlitchedDeals is not affiliated with, endorsed by, or sponsored by any
              retailer or brand mentioned on our platform. We are an independent
              deal-finding community.
            </p>
            <p>
              All product names, logos, and brands are property of their respective owners.
              Use of these names and brands does not imply endorsement.
            </p>
          </section>

          <section className="legal-section">
            <h2>Price Errors</h2>
            <p>
              Price errors are mistakes made by retailers in their pricing systems.
              While we share information about price errors:
            </p>
            <ul>
              <li>Retailers are not obligated to honor price errors</li>
              <li>Orders placed on price errors may be cancelled by retailers</li>
              <li>You use price error information at your own discretion</li>
              <li>We are not responsible for cancelled orders or disputes</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, GlitchedDeals and its operators
              shall not be liable for any:
            </p>
            <ul>
              <li>Indirect, incidental, or consequential damages</li>
              <li>Lost profits or savings</li>
              <li>Issues arising from using deal information</li>
              <li>Problems with retailers or purchases</li>
              <li>Errors or omissions in deal information</li>
              <li>Service interruptions or unavailability</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>User-Generated Content</h2>
            <p>
              If you post content in our Discord or other platforms, you:
            </p>
            <ul>
              <li>Grant us a license to use, display, and share that content</li>
              <li>Confirm you have the right to share the content</li>
              <li>Are responsible for the accuracy of your posts</li>
              <li>May have your content removed if it violates our guidelines</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              The GlitchedDeals name, logo, and original content are our intellectual
              property. You may not use them without our permission. This does not
              apply to retailer trademarks, which belong to their respective owners.
            </p>
          </section>

          <section className="legal-section">
            <h2>Termination</h2>
            <p>
              We reserve the right to terminate or suspend access to our services at any
              time, without notice, for conduct that violates these Terms or is harmful
              to other users, us, or third parties.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Platforms</h2>
            <p>
              Our services utilize third-party platforms including Discord, Twitter/X,
              and various websites. Your use of these platforms is subject to their
              respective terms of service and privacy policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of our services
              after changes constitutes acceptance of the modified Terms. We encourage
              you to review these Terms periodically.
            </p>
          </section>

          <section className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with applicable
              laws, without regard to conflict of law principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>
              If you have questions about these Terms, please contact us:
            </p>
            <ul>
              <li>Via Discord: <a href="https://discord.gg/explorer" target="_blank" rel="noopener noreferrer">discord.gg/explorer</a></li>
              <li>Via Twitter/X: <a href="https://twitter.com/GlitchedDeals" target="_blank" rel="noopener noreferrer">@GlitchedDeals</a></li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable, the remaining
              provisions will continue in full force and effect.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
